export default __webpack_public_path__ + "static/media/dashboard.f28e8a23.svg";